var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeletedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.426,
    height: 15.266,
    viewBox: "0 0 12.426 15.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M15.255,5.783a.533.533,0,0,0-.533-.533H4.783a.533.533,0,0,0-.533.533v9.585a2.308,2.308,0,0,0,2.308,2.308h6.39a2.308,2.308,0,0,0,2.308-2.308Zm-1.065.533v9.053a1.244,1.244,0,0,1-1.243,1.243H6.558a1.244,1.244,0,0,1-1.243-1.243V6.315Z",
    transform: "translate(-0.29 -1.16)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M13.673,5.155a.533.533,0,0,0,.533-.533V3.2A1.951,1.951,0,0,0,12.253,1.25H8.7A1.951,1.951,0,0,0,6.75,3.2v1.42a.533.533,0,0,0,.533.533ZM13.14,4.09H7.815V3.2A.887.887,0,0,1,8.7,2.315h3.55a.887.887,0,0,1,.888.888Z",
    transform: "translate(-1.015)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M15.143,5.25H3.783a.533.533,0,0,0,0,1.065h11.36a.533.533,0,1,0,0-1.065Z",
    transform: "translate(0 -1.16)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M8.75,10.283v4.97a.533.533,0,1,0,1.065,0v-4.97a.533.533,0,0,0-1.065,0Z",
    transform: "translate(-1.595 -2.465)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M13.75,10.283v4.97a.533.533,0,1,0,1.065,0v-4.97a.533.533,0,0,0-1.065,0Z",
    transform: "translate(-3.045 -2.465)",
    fill: "#707070",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletedicon);
export default __webpack_public_path__ + "static/media/deletedicon.46e7a30719bfae913277fd338048b6f5.svg";
export { ForwardRef as ReactComponent };